import { render, staticRenderFns } from "./single-uploader.vue?vue&type=template&id=8f071fb0&scoped=true&lang=pug&"
import script from "./single-uploader.vue?vue&type=script&lang=js&"
export * from "./single-uploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f071fb0",
  null
  
)

export default component.exports